import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-logo ',
  template: `<img
    class="bigLogo"
    [src]="type ? 'assets/images/logoLight.svg' : 'assets/images/logoDark.svg'"
    alt="Logo"
  />`,
})
export class LogoComponent {
  @Input() type: any;
}
